import AccountNew from './AccountNew'

export default AccountNew;